import { useEffect, useState } from "react";
import { api } from "./api";

export function useCustomers() {
  const [customers, setCustomers] = useState([]);
  const reload = () => api.get("/customers").then((r) => setCustomers(r.data));
  useEffect(() => { reload(); }, []);
  return { customers, reload };
}

export function usePoll(fn, ms, deps = []) {
  useEffect(() => {
    fn();
    const t = setInterval(fn, ms);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export function useSelectedCustomer(customers) {
  const [cid, setCid] = useState(localStorage.getItem("sr_customer") || "");
  useEffect(() => {
    if (customers.length && !customers.find((c) => c.id === cid)) setCid(customers[0].id);
  }, [customers, cid]);
  useEffect(() => { if (cid) localStorage.setItem("sr_customer", cid); }, [cid]);
  return [cid, setCid];
}
